import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';

export class GemsDynamicComponentHelper {
  public static components: any;

  public static init() {
    if (GemsDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    GemsDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static register(key: string, component: any) {
    GemsDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
